import React from 'react';
import { customerCreate } from '../../../../../helpers/customer-helper';

const getTodayDate = () => new Date().toISOString().slice(0, 10);

export const useCustomerCreateForm = ({ token, navigate }) => {
    const [isSaving, setIsSaving] = React.useState(false);
    const [error, setError] = React.useState('');
    const [form, setForm] = React.useState({
        name: '',
        description: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        joinDate: getTodayDate(),
    });

    const handleInputChange = React.useCallback((event) => {
        const { name, value } = event.target;
        setForm((previous) => ({
            ...previous,
            [name]: value,
        }));
    }, []);

    const handleSubmit = React.useCallback(async (event) => {
        event.preventDefault();

        if (!token || isSaving) {
            return;
        }

        setIsSaving(true);
        setError('');

        const payload = {
            name: form.name.trim(),
            description: form.description.trim(),
            contactName: form.contactName.trim(),
            contactEmail: form.contactEmail.trim(),
            contactPhone: form.contactPhone.trim(),
            joinDate: form.joinDate,
        };

        const resp = await customerCreate(token, payload);

        if (!resp?.success) {
            setError(resp?.message || 'No se pudo crear el cliente.');
            setIsSaving(false);
            return;
        }

        const customerId = resp?.data?._id;
        if (customerId) {
            navigate(`/customer/detail/${customerId}`, {
                state: {
                    customerName: resp?.data?.name,
                },
            });
            return;
        }

        navigate('/customer/list');
    }, [token, isSaving, form, navigate]);

    const handleCancel = React.useCallback(() => {
        navigate('/customer/list');
    }, [navigate]);

    return {
        isSaving,
        error,
        form,
        handleInputChange,
        handleSubmit,
        handleCancel,
    };
};
